<template>
    <v-container class="pa-2">
        <v-row dense>
            <v-col cols="12">

                <!-- ── Slave: Seleziona schema ──────────────────────────── -->
                <SelectSchema
                    v-if="showSelectSchema"
                    :items="schemiVisibili"
                    :loading="loadingSchemi"
                    :isInterno="true"
                    :soloSchemiNonSvolti="soloSchemiNonSvolti"
                    :oratoreFiltro="null"
                    :congregazioneFiltro="null"
                    @selected="onSchemaSelected"
                    @update:soloSchemiNonSvolti="soloSchemiNonSvolti = $event"
                    @close="showSelectSchema = false"
                />

                <template v-else>

                <!-- Header -->
                <v-card class="rounded-xl elevation-2 px-3 py-2 mb-3">
                    <div class="d-flex align-center">
                        <v-btn icon small text color="primary" @click="chiudi()">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <div class="ml-2 flex-grow-1">
                            <div class="text-subtitle-2 font-weight-bold primary--text">
                                {{ isNuovo ? 'Appuntamento interno oratore fuori circoscrizione' : 'Modifica appuntamento interno fuori circoscrizione' }}
                            </div>
                            <div v-if="dataLocale" class="text-caption grey--text text-capitalize">{{ dataLocale }}</div>
                        </div>
                        <v-icon color="primary" size="28">mdi-home-outline</v-icon>
                    </div>
                </v-card>

                <!-- Skeleton -->
                <v-card v-if="loading" class="rounded-xl elevation-2 pa-4">
                    <v-skeleton-loader type="list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, actions" />
                </v-card>

                <!-- Form -->
                <v-card v-else class="rounded-xl elevation-2">
                    <v-card-text class="pt-4 pb-2">
                        <v-form v-model="valid" ref="formProgramma" lazy-validation>

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-home-city-outline</v-icon>
                                Congregazione
                            </div>
                            <v-text-field
                                v-model="programma.congregazioneExtra"
                                outlined rounded dense
                                :rules="congregazioneRules"
                                placeholder="Nome congregazione"
                                class="mb-1"
                            />

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-account-outline</v-icon>
                                Oratore
                            </div>
                            <v-text-field
                                v-model="programma.oratoreExtra"
                                outlined rounded dense
                                :rules="oratoreRules"
                                placeholder="Nome oratore"
                                class="mb-1"
                            />

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-book-open-outline</v-icon>
                                Discorso
                            </div>

                            <!-- Card se schema già selezionato, altrimenti bottone -->
                            <v-card v-if="discorsoId" outlined
                                    class="rounded-lg px-3 py-2 mb-3 selezionato-card"
                                    @click="showSelectSchema = true">
                                <div class="d-flex align-center">
                                    <span class="numero-schema mr-3 flex-shrink-0">{{ schemaSelezionatoNumero || '—' }}</span>
                                    <span class="text-body-2 flex-grow-1" style="white-space:normal">{{ schemaSelezionatoTema }}</span>
                                    <v-icon small color="grey">mdi-pencil-outline</v-icon>
                                </div>
                            </v-card>
                            <v-btn v-else block outlined rounded color="primary" class="mb-3"
                                   :loading="loadingSchemi"
                                   @click="showSelectSchema = true">
                                <v-icon left>mdi-book-open-outline</v-icon>
                                Scegli schema
                            </v-btn>
                            <!-- Campo nascosto per la validazione -->
                            <v-input :value="discorsoId" :rules="discorsoRules" class="mt-n3 mb-1" style="display:none" />

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-music-note</v-icon>
                                Cantico
                            </div>
                            <v-text-field
                                v-model="programma.cantico"
                                outlined rounded dense
                                placeholder="Numero cantico"
                            />

                        </v-form>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions class="px-4 py-3">
                        <v-btn text rounded @click="chiudi()">Annulla</v-btn>
                        <v-spacer />
                        <v-btn color="primary" rounded depressed :loading="loadingSalva" :disabled="!valid || !discorsoId" @click="saveProgramma">
                            {{ isNuovo ? 'Salva' : 'Aggiorna' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>

                </template><!-- end v-else (form principale) -->

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { callService, callPost, gLocalData } from '@/modules/utilities.js';
import { VSkeletonLoader } from 'vuetify/lib';
import { bus } from '@/main.js';
import SelectSchema from '@/views/SelectSchema.vue';

export default {
    components: { VSkeletonLoader, SelectSchema },
    props: {
        inlineId:   { default: null },
        inlineData: { default: null },
    },
    data: () => ({
        loading: false,
        loadingSalva: false,
        loadingSchemi: false,
        valid: false,
        programma: {
            isExtra: true,
            isProvvisorio: false,
            oratore: { id: null },
            discorso: { diId: null },
            cantico: '',
            oratoreExtra: '',
            congregazioneExtra: '',
        },
        congregazioneRules: [v => !!v || 'La congregazione è obbligatoria'],
        oratoreRules:       [v => !!v || 'Il nome dell\'oratore è obbligatorio'],
        discorsoRules:      [v => !!v || 'Il discorso è obbligatorio'],
        schemiInfo: [],           // [{ discorso, ultimaData, ultimoOratore }]
        discorsoId: null,         // UUID dello schema selezionato
        showSelectSchema: false,
        soloSchemiNonSvolti: true,
        dataLocale: null,
        isNuovo: true,
    }),
    computed: {
        isInline() {
            return this.inlineId !== null || this.inlineData !== null;
        },
        schemiVisibili() {
            let lista = this.schemiInfo.filter(s =>
                s.discorso?.diId === 99999 || !s.discorso?.isOscurato
            );
            if (this.soloSchemiNonSvolti) {
                const unAnnoFa = new Date();
                unAnnoFa.setFullYear(unAnnoFa.getFullYear() - 1);
                lista = lista.filter(s =>
                    s.discorso?.diId === 99999 ||
                    !s.ultimaData ||
                    new Date(s.ultimaData) < unAnnoFa
                );
            }
            // Garantisce che lo schema già selezionato sia sempre visibile
            if (this.discorsoId && !lista.find(s => s.discorso?.id === this.discorsoId)) {
                const trovato = this.schemiInfo.find(s => s.discorso?.id === this.discorsoId);
                if (trovato) lista = [trovato, ...lista];
            }
            return lista;
        },
        schemaSelezionatoNumero() {
            if (!this.discorsoId) return null;
            const s = this.schemiInfo.find(s => s.discorso?.id === this.discorsoId);
            return s?.discorso?.diId === 99999 ? '-' : (s?.discorso?.diId || null);
        },
        schemaSelezionatoTema() {
            if (!this.discorsoId) return '';
            const s = this.schemiInfo.find(s => s.discorso?.id === this.discorsoId);
            return s?.discorso?.tema || '';
        },
    },
    async mounted() {
        if (this.isInline) await this.loadInline();
    },
    async created() {
        this.loadingSchemi = true;
        try {
            const lista = await callService('/api/discorso/listaInfo', [
                this.$store.state.idCircoscrizione,
                this.$store.state.idCongregazione,
                true,   // isInterno → recupera ultimaData per la nostra congregazione
                false,  // ultimoAnno: filtro gestito in computed
            ]) || [];
            // "Da stabilire" sempre in cima
            const idxDs = lista.findIndex(s => s.discorso?.diId === 99999);
            if (idxDs > 0) lista.unshift(lista.splice(idxDs, 1)[0]);
            else if (idxDs === -1) lista.unshift({ discorso: { diId: 99999, tema: 'Da stabilire' }, ultimaData: null, ultimoOratore: null });
            this.schemiInfo = lista;
        } catch (error) {
            console.error('Errore durante il recupero degli schemi:', error);
        } finally {
            this.loadingSchemi = false;
        }
    },
    watch: {
        inlineId(val) { if (val !== null) this.loadInline(); },
        inlineData(val) { if (val !== null) this.loadInline(); },
        '$route.params': {
            immediate: true,
            async handler(params) {
                if (this.isInline) return;
                const id = params.id;
                const data = this.$route.query.data;
                this.isNuovo = !id;

                if (id) {
                    this.loading = true;
                    try {
                        const apiParams = [this.$store.state.idCircoscrizione, this.$store.state.idCongregazione];
                        const [programma] = await callService(`/api/Programma/interno?idProgramma=${encodeURIComponent(id)}`, apiParams);
                        if (programma) {
                            this.programma = programma;
                            if (!this.programma.discorso) this.programma.discorso = { diId: null };
                            if (!this.programma.oratore)  this.programma.oratore  = { id: null };
                            if (!this.programma.cantico)  this.programma.cantico  = '';
                            const discorsoId = this.programma.discorso?.id;
                            this.discorsoId = discorsoId || await this.discorsoIdDaStabilire();
                            this.dataLocale = gLocalData(new Date(this.programma.data));
                        }
                    } catch (error) {
                        console.error('Errore durante il recupero del programma:', error);
                    } finally {
                        this.loading = false;
                    }
                } else if (data) {
                    this.resetForm(data);
                    this.dataLocale = gLocalData(new Date(data));
                }
            }
        }
    },
    methods: {
        chiudi() {
            if (this.isInline) this.$emit('close');
            else this.$router.back();
        },

        resetForm(data) {
            this.programma = {
                isExtra: true,
                isProvvisorio: false,
                oratore: { id: null },
                discorso: { diId: null },
                cantico: '',
                oratoreExtra: '',
                congregazioneExtra: '',
                data,
            };
            this.discorsoId = null;
            this.$nextTick(() => {
                if (this.$refs.formProgramma) this.$refs.formProgramma.resetValidation();
            });
        },

        onSchemaSelected(discorsoId) {
            this.discorsoId = discorsoId;
            this.showSelectSchema = false;
        },

        async loadInline_byId(id) {
            this.isNuovo = false;
            this.loading = true;
            try {
                const apiParams = [this.$store.state.idCircoscrizione, this.$store.state.idCongregazione];
                const [programma] = await callService(`/api/Programma/interno?idProgramma=${encodeURIComponent(id)}`, apiParams);
                if (programma) {
                    this.programma = programma;
                    if (!this.programma.discorso) this.programma.discorso = { diId: null };
                    if (!this.programma.oratore)  this.programma.oratore  = { id: null };
                    if (!this.programma.cantico)  this.programma.cantico  = '';
                    const discorsoId = this.programma.discorso?.id;
                    this.discorsoId = discorsoId || await this.discorsoIdDaStabilire();
                    this.dataLocale = gLocalData(new Date(this.programma.data));
                }
            } catch (error) {
                console.error('Errore durante il recupero del programma:', error);
            } finally {
                this.loading = false;
            }
        },

        // Restituisce l'id di "da stabilire" da schemiInfo, attendendo se ancora in caricamento
        async discorsoIdDaStabilire() {
            if (this.loadingSchemi) {
                await new Promise(resolve => {
                    const unwatch = this.$watch('loadingSchemi', loading => {
                        if (!loading) { unwatch(); resolve(); }
                    });
                });
            }
            const ds = this.schemiInfo.find(s => s.discorso?.diId === 99999);
            return ds?.discorso?.id || null;
        },

        async loadInline() {
            this.isNuovo = !this.inlineId;
            if (this.isNuovo) {
                this.resetForm(this.inlineData);
                if (this.inlineData) this.dataLocale = gLocalData(new Date(this.inlineData));
            } else {
                await this.loadInline_byId(this.inlineId);
            }
        },

        async saveProgramma() {
            if (!this.$refs.formProgramma.validate()) return;
            if (!this.discorsoId) return;
            this.loadingSalva = true;
            try {
                const schemaCompleto = this.schemiInfo.find(s => s.discorso?.id === this.discorsoId)?.discorso
                    || { id: this.discorsoId };

                const paramJson = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.oratore.codice,
                    token: this.$store.state.oratore.token,
                    idCircoscrizione: this.$store.state.idCircoscrizione,
                    programma: {
                        ...this.programma,
                        discorso: schemaCompleto,
                        congregazione: { id: this.$store.state.idCongregazione },
                    },
                    interno: true
                };
                const service = this.isNuovo ? 'salva' : 'aggiorna';
                const response = await callPost(`/api/programma/${service}`, paramJson);
                bus.$emit(this.isNuovo ? 'add-programma' : 'update-programma', response);
                if (this.isInline) {
                    await this.loadInline_byId(response.id);
                } else {
                    this.chiudi();
                }
            } catch (error) {
                console.error('Errore durante il salvataggio:', error);
            } finally {
                this.loadingSalva = false;
            }
        },
    },
};
</script>

<style scoped>
.field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0,0,0,0.55);
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}
.theme--dark .field-label {
    color: rgba(255,255,255,0.5);
}
.numero-schema {
    font-size: 0.72rem;
    font-weight: 700;
    padding: 1px 7px;
    border-radius: 6px;
    background-color: rgba(0,0,0,0.08);
    white-space: nowrap;
}
.theme--dark .numero-schema {
    background-color: rgba(255,255,255,0.12);
}
.selezionato-card {
    cursor: pointer;
    border-color: rgba(var(--v-primary-base), 0.4) !important;
}
.selezionato-card:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.12) !important;
}
</style>
